import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminNavBarMain from "./AdminNavBarMain";
import axios from ".././axios-interceptor";
import { base_url } from "./../utilities";
import { toast } from "react-toastify";
import Cookies from "js-cookie";

const AdminSettings = () => {
  const navigate = useNavigate();

  const [tier2Rate, setTier2Rate]       = useState(null)
  const [editRate, setEditRate]         = useState("")
  const [isEditing, setIsEditing]       = useState(false)
  const [loading, setLoading]           = useState(true)
  const [saving, setSaving]             = useState(false)

  useEffect(() => {
    if (!Cookies.get("User_Accesstoken_Admin")) {
      navigate("/adminlogin")
    }
    fetchTier2Rate()
  }, [])

  const fetchTier2Rate = () => {
    setLoading(true)
    axios.post(base_url + "system-settings/get_tier2_rate")
      .then(res => {
        if (res.data.status === 200) {
          setTier2Rate(res.data.data.value)
          setEditRate(res.data.data.value)
        }
      })
      .catch(err => console.log(err))
      .finally(() => setLoading(false))
  }

  const handleSave = () => {
    if (editRate === "" || isNaN(editRate)) {
      toast.error("Please enter a valid number", { toastId: 1 })
      return
    }
    if (Number(editRate) < 0 || Number(editRate) > 10) {
      toast.error("Rate must be between 0 and 10", { toastId: 2 })
      return
    }
    setSaving(true)
    axios.post(base_url + "system-settings/update_tier2_rate", {
      value:           Number(editRate),
      admin_user_id:   Cookies.get("admin_user_id"),
      admin_user_name: Cookies.get("admin_user_name")
    })
      .then(res => {
        if (res.data.status === 200) {
          setTier2Rate(Number(editRate))
          setIsEditing(false)
          toast.success("Tier 2 rate updated successfully", { toastId: 3 })
        }
      })
      .catch(err => console.log(err))
      .finally(() => setSaving(false))
  }

  const handleCancel = () => {
    setEditRate(tier2Rate)
    setIsEditing(false)
  }

  return (
    <div>
      <AdminNavBarMain />
      <div className="row admin_body_main bg-transparent mt-1">
        <div className="d-flex justify-content-between mb-3">
          <h5
            className="admin_serv mb-2 Cpointer"
            onClick={() => navigate("/admindashboard")}
          >
            <img
              src="./images/left_arrow.svg"
              alt=""
              className="indiv_loan_dtls"
            />
            &nbsp; System Settings
          </h5>
        </div>

        <div className="container p-0">

          {/* Penalty Configuration Section */}
          <div className="card p-4 mb-4" style={{ maxWidth: 600 }}>
            <h6 className="mb-1" style={{ fontWeight: 600 }}>
              Penalty Configuration
            </h6>
            <p className="text_st mb-4">
              Configure the penalty rates applied when borrowers make late payments.
            </p>

            {/* Tier 1 — read only, informational */}
            <div className="mb-4">
              <div className="d-flex justify-content-between align-items-center p-3"
                style={{
                  background: '#f8f9fa',
                  borderRadius: 8,
                  border: '1px solid #e9ecef'
                }}
              >
                <div>
                  <p className="mb-0" style={{ fontWeight: 500, fontSize: 14 }}>
                    Tier 1 — Days 1 to 30
                  </p>
                  <p className="mb-0 text_st" style={{ fontSize: 12 }}>
                    Standard penalty rate — same as loan monthly return rate
                  </p>
                </div>
                <div style={{
                  background: '#e8f0fe',
                  color: '#185FA5',
                  padding: '4px 12px',
                  borderRadius: 6,
                  fontWeight: 600,
                  fontSize: 14
                }}>
                  Loan rate %
                </div>
              </div>
            </div>

            {/* Tier 2 — configurable */}
            <div>
              <div className="d-flex justify-content-between align-items-center p-3"
                style={{
                  background: '#fff8f8',
                  borderRadius: 8,
                  border: '1px solid #f5c6c6'
                }}
              >
                <div>
                  <p className="mb-0" style={{ fontWeight: 500, fontSize: 14 }}>
                    Tier 2 — Day 31 onwards
                  </p>
                  <p className="mb-0 text_st" style={{ fontSize: 12 }}>
                    Escalation added on top of loan monthly return rate
                  </p>
                </div>
                <div className="d-flex align-items-center gap-2">
                  {loading ? (
                    <span style={{ fontSize: 13, color: '#888' }}>Loading...</span>
                  ) : isEditing ? (
                    <div className="d-flex align-items-center gap-2">
                      <div className="d-flex align-items-center"
                        style={{
                          border: '1px solid #E24B4A',
                          borderRadius: 6,
                          overflow: 'hidden'
                        }}
                      >
                        <input
                          type="number"
                          value={editRate}
                          min={0}
                          max={10}
                          step={0.5}
                          style={{
                            width: 70,
                            border: 'none',
                            padding: '6px 8px',
                            fontSize: 14,
                            fontWeight: 600,
                            outline: 'none',
                            textAlign: 'center'
                          }}
                          onChange={e => setEditRate(e.target.value)}
                        />
                        <span style={{
                          padding: '6px 10px',
                          background: '#f5f5f5',
                          fontSize: 14,
                          fontWeight: 600,
                          color: '#E24B4A'
                        }}>
                          %
                        </span>
                      </div>
                      <button
                        className="btn btn-sm blue_btn px-3"
                        onClick={handleSave}
                        disabled={saving}
                      >
                        {saving ? 'Saving...' : 'Save'}
                      </button>
                      <button
                        className="btn btn-sm btn_background px-3"
                        onClick={handleCancel}
                        disabled={saving}
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center gap-2">
                      <div style={{
                        background: '#fdecea',
                        color: '#E24B4A',
                        padding: '4px 12px',
                        borderRadius: 6,
                        fontWeight: 600,
                        fontSize: 14
                      }}>
                        +{tier2Rate}%
                      </div>
                      <img
                        src="./images/pen.svg"
                        alt="edit"
                        style={{ cursor: 'pointer', width: 16 }}
                        onClick={() => setIsEditing(true)}
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* Example box */}
              {tier2Rate !== null && (
                <div className="mt-3 p-3"
                  style={{
                    background: '#f0f4ff',
                    borderRadius: 8,
                    fontSize: 12,
                    color: '#555'
                  }}
                >
                  <strong style={{ color: '#185FA5' }}>Example:</strong> For a loan with 4% monthly rate,
                  a payment 45 days late would incur:
                  <br />
                  Tier 1 (days 1–30): 4% daily rate × 30 days
                  <br />
                  Tier 2 (days 31–45): {(4 + Number(tier2Rate)).toFixed(1)}% daily rate × 15 days
                </div>
              )}
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default AdminSettings